/**
 * Search Overlay Handler
 * Handles the functionality of a search overlay, including open/close controls,
 * inert attribute management for accessibility, and search suggestions with autocomplete.
 */

document.addEventListener("DOMContentLoaded", () => {
	// Select all search overlay toggle buttons
	const searchButtons = document.querySelectorAll(
		".bds-search-overlay-toggle",
	);
	if (!searchButtons.length) return;
	let lastSearchButton = null;

	// Check if the search overlay exists; if not, initialize it
	let overlay = document.querySelector("#bds-search-dialog");

	if (!overlay) {
		overlay = document.createElement("div");
		overlay.id = "bds-search-dialog";
		overlay.className = "bds-search-dialog";
		overlay.setAttribute("tabindex", "-1");
		overlay.setAttribute("role", "dialog");
		overlay.setAttribute("aria-modal", "true");

		// Set up the search form inside the overlay
		overlay.innerHTML = `
            <button type="button" class="bds-search-dialog__close" aria-label="Close search dialog"></button>
            <form method="get" action="/" role="search" class="bds-search-dialog__form">
                <label for="bds-search-input" class="screen-reader-text">Search</label>
                <input id="bds-search-input" name="s" type="search" placeholder="Search..." autofocus />
                <button type="submit">
                    <span class="sr-only">Search</span>
                </button>
            </form>
        `;

		document.body.appendChild(overlay);
	}

	/**
	 * Helper Functions: Manage inert attributes on the page
	 */
	function setInertOnPage(exceptOverlay) {
		document.querySelectorAll("body > *").forEach((el) => {
			if (el !== exceptOverlay) el.setAttribute("inert", "");
		});
	}

	function removeInertFromPage() {
		document
			.querySelectorAll("[inert]")
			.forEach((el) => el.removeAttribute("inert"));
	}

	/**
	 * Opens the search overlay
	 */
	function openOverlay() {
		overlay.classList.add("active");
		document.body.classList.add("bds-search-overlay-open");
		setInertOnPage(overlay);

		setTimeout(() => {
			const input = overlay.querySelector("input[type='search']");
			if (input) {
				// Populate the search input with the current query (if any)
				const params = new URLSearchParams(window.location.search);
				const searchValue = params.get("s");
				if (searchValue) input.value = searchValue;
				input.focus();
			}
		}, 10);
	}

	/**
	 * Closes the search overlay
	 */
	function closeOverlay() {
		overlay.classList.remove("active");
		document.body.classList.remove("bds-search-overlay-open");
		removeInertFromPage();
		if (lastSearchButton) lastSearchButton.focus();
	}

	/**
	 * Event Listeners: Open and close overlay
	 */
	document.addEventListener("click", (e) => {
		const button = e.target.closest(".bds-search-overlay-toggle");
		if (button) {
			e.preventDefault();
			openOverlay();
			lastSearchButton = button;
		}
	});

	overlay.addEventListener("click", (e) => {
		if (e.target === overlay) {
			closeOverlay();
		}
	});

	const closeButton = overlay.querySelector(".bds-search-dialog__close");
	if (closeButton) {
		closeButton.addEventListener("click", closeOverlay);
	}

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && overlay.classList.contains("active")) {
			closeOverlay();
		}
	});
});
